export default function validate(orders) {
	let orderValidationResult = [];


	for (let order of orders) {
		let orderValidationObject = { order, validationErrors: [] };
		hasEtd(orderValidationObject);
		hasOrderType(orderValidationObject);
		hasDespatchParty(orderValidationObject);
		hasDeliveryParty(orderValidationObject);
		hasFreightWeight(orderValidationObject);
		orderValidationResult.push(orderValidationObject);
	}

	function hasFreightWeight(orderValidationObject) {
		if (orderValidationObject.order.grossWeight !== 0)
			return;
		addValidationToArray(orderValidationObject, 'missingFreightWeight');
	}

	function hasEtd(orderValidationObject) {
		if (orderValidationObject.order.etd && orderValidationObject.order.etd.date)
			return;
		addValidationToArray(orderValidationObject, 'missingEtd');
	}

	function hasDespatchParty(orderValidationObject) {
		if (orderValidationObject.order.despatchParty && orderValidationObject.order.despatchParty.name)
			return;
		addValidationToArray(orderValidationObject, 'missingDespatchParty');
	}

	function hasDeliveryParty(orderValidationObject) {
		if (orderValidationObject.order.deliveryParty && orderValidationObject.order.deliveryParty.name)
			return;
		addValidationToArray(orderValidationObject, 'missingDeliveryParty');
	}

	function hasOrderType(orderValidationObject) {
		if (orderValidationObject.order.orderType)
			return;
		addValidationToArray(orderValidationObject, 'missingOrderType');
	}

	function addValidationToArray(orderValidationObject, key) {
		orderValidationObject.validationErrors.push(key);
			
	}

	return orderValidationResult;
}